window.slate = window.slate || {};
window.theme = window.theme || {};
window.theme.compareToolSettings = window.theme.compareToolSettings || {};

Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function (cents, format) {
    if (typeof cents == "string") {
        cents = cents.replace(".", "");
    }
    var value = "";
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || this.money_format;

    function defaultOption(opt, def) {
        return typeof opt == "undefined" ? def : opt;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ",");
        decimal = defaultOption(decimal, ".");

        if (isNaN(number) || number == null) {
            return 0;
        }

        number = (number / 100.0).toFixed(precision);

        var parts = number.split("."),
            dollars = parts[0].replace(
                /(\d)(?=(\d\d\d)+(?!\d))/g,
                "$1" + thousands
            ),
            cents = parts[1] ? decimal + parts[1] : "";

        return dollars + cents;
    }

    switch (formatString.match(placeholderRegex)[1]) {
        case "amount":
            value = formatWithDelimiters(cents, 2);
            break;
        case "amount_no_decimals":
            value = formatWithDelimiters(cents, 0);
            break;
        case "amount_with_comma_separator":
            value = formatWithDelimiters(cents, 2, ".", ",");
            break;
        case "amount_no_decimals_with_comma_separator":
            value = formatWithDelimiters(cents, 0, ".", ",");
            break;
    }

    return formatString.replace(placeholderRegex, value);
};

slate.utils = {
    /**
     * Return an object from an array of objects that matches the provided key and value
     *
     * @param {array} array - Array of objects
     * @param {string} key - Key to match the value against
     * @param {string} value - Value to get match of
     */
    findInstance: function (array, key, value) {
        for (var i = 0; i < array.length; i++) {
            if (array[i][key] === value) {
                return array[i];
            }
        }
    },

    /**
     * Remove an object from an array of objects by matching the provided key and value
     *
     * @param {array} array - Array of objects
     * @param {string} key - Key to match the value against
     * @param {string} value - Value to get match of
     */
    removeInstance: function (array, key, value) {
        var i = array.length;
        while (i--) {
            if (array[i][key] === value) {
                array.splice(i, 1);
                break;
            }
        }

        return array;
    },

    /**
     * _.compact from lodash
     * Remove empty/false items from array
     * Source: https://github.com/lodash/lodash/blob/master/compact.js
     *
     * @param {array} array
     */
    compact: function (array) {
        var index = -1;
        var length = array == null ? 0 : array.length;
        var resIndex = 0;
        var result = [];

        while (++index < length) {
            var value = array[index];
            if (value) {
                result[resIndex++] = value;
            }
        }
        return result;
    },

    /**
     * _.defaultTo from lodash
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
     *
     * @param {*} value - Value to check
     * @param {*} defaultValue - Default value
     * @returns {*} - Returns the resolved value
     */
    defaultTo: function (value, defaultValue) {
        return value == null || value !== value ? defaultValue : value;
    }
};

slate.Sections = function Sections() {
    this.constructors = {};
    this.instances = [];

    $(document)
        .on("shopify:section:load", this._onSectionLoad.bind(this))
        .on("shopify:section:unload", this._onSectionUnload.bind(this))
        .on("shopify:section:select", this._onSelect.bind(this))
        .on("shopify:section:deselect", this._onDeselect.bind(this))
        .on("shopify:section:reorder", this._onReorder.bind(this))
        .on("shopify:block:select", this._onBlockSelect.bind(this))
        .on("shopify:block:deselect", this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
    _createInstance: function (container, constructor) {
        var $container = $(container);
        var id = $container.attr("data-section-id");
        var type = $container.attr("data-section-type");

        constructor = constructor || this.constructors[type];

        if (typeof constructor === "undefined") {
            return;
        }

        var instance = $.extend(new constructor(container), {
            id: id,
            type: type,
            container: container
        });

        this.instances.push(instance);
    },

    _onSectionLoad: function (evt) {
        var container = $("[data-section-id]", evt.target)[0];
        if (container) {
            this._createInstance(container);
        }
    },

    _onSectionUnload: function (evt) {
        var instance = slate.utils.findInstance(
            this.instances,
            "id",
            evt.detail.sectionId
        );

        if (!instance) {
            return;
        }

        if (typeof instance.onUnload === "function") {
            instance.onUnload(evt);
        }

        this.instances = slate.utils.removeInstance(
            this.instances,
            "id",
            evt.detail.sectionId
        );
    },

    _onSelect: function (evt) {
        var instance = slate.utils.findInstance(
            this.instances,
            "id",
            evt.detail.sectionId
        );

        if (instance && typeof instance.onSelect === "function") {
            instance.onSelect(evt);
        }
    },

    _onDeselect: function (evt) {
        var instance = slate.utils.findInstance(
            this.instances,
            "id",
            evt.detail.sectionId
        );

        if (instance && typeof instance.onDeselect === "function") {
            instance.onDeselect(evt);
        }
    },

    _onReorder: function (evt) {
        var instance = slate.utils.findInstance(
            this.instances,
            "id",
            evt.detail.sectionId
        );

        if (instance && typeof instance.onReorder === "function") {
            instance.onReorder(evt);
        }
    },

    _onBlockSelect: function (evt) {
        var instance = slate.utils.findInstance(
            this.instances,
            "id",
            evt.detail.sectionId
        );

        if (instance && typeof instance.onBlockSelect === "function") {
            instance.onBlockSelect(evt);
        }
    },

    _onBlockDeselect: function (evt) {
        var instance = slate.utils.findInstance(
            this.instances,
            "id",
            evt.detail.sectionId
        );

        if (instance && typeof instance.onBlockDeselect === "function") {
            instance.onBlockDeselect(evt);
        }
    },

    register: function (type, constructor) {
        this.constructors[type] = constructor;

        $("[data-section-type=" + type + "]").each(
            function (index, container) {
                this._createInstance(container, constructor);
            }.bind(this)
        );
    }
});

slate.Image = (function () {
    /**
     * Preloads an image in memory and uses the browsers cache to store it until needed.
     *
     * @param {Array} images - A list of image urls
     * @param {String} size - A shopify image size attribute
     */

    function preload(images, size) {
        if (typeof images === "string") {
            images = [images];
        }

        for (var i = 0; i < images.length; i++) {
            var image = images[i];
            this.loadImage(this.getSizedImageUrl(image, size));
        }
    }

    /**
     * Loads and caches an image in the browsers cache.
     * @param {string} path - An image url
     */
    function loadImage(path) {
        new Image().src = path;
    }

    /**
     * Find the Shopify image attribute size
     *
     * @param {string} src
     * @returns {null}
     */
    function imageSize(src) {
        var match = src.match(
            /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/
        );

        if (match) {
            return match[1];
        } else {
            return null;
        }
    }

    /**
     * Adds a Shopify size attribute to a URL
     *
     * @param src
     * @param size
     * @returns {*}
     */
    function getSizedImageUrl(src, size) {
        if (size === null) {
            return src;
        }

        if (size === "master") {
            return this.removeProtocol(src);
        }

        var match = src.match(
            /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif|webp)(\?v=\d+)?$/i
        );

        if (match) {
            var prefix = src.split(match[0]);
            var suffix = match[0];

            return this.removeProtocol(prefix[0] + "_" + size + suffix);
        } else {
            return null;
        }
    }

    function removeProtocol(path) {
        return path.replace(/http(s)?:/, "");
    }

    return {
        preload: preload,
        loadImage: loadImage,
        imageSize: imageSize,
        getSizedImageUrl: getSizedImageUrl,
        removeProtocol: removeProtocol
    };
})();

window.theme = window.theme || {};

theme.utils = {
    /**
     * Turns a string into a handle. Mimics Shopify's format.
     */
    handleize: function (str) {
        return str
            .toLowerCase()
            .replace(/[^\w\u00C0-\u024f]+/g, "-")
            .replace(/^-+|-+$/g, "");
    },

    /**
     * Cross-browser URL query param getter
     */
    getQueryParams: function (qs) {
        qs = qs || document.location.search;

        if (!qs) {
            return;
        }

        qs = qs.split("+").join(" ");

        var params = {},
            tokens,
            re = /[?&]?([^=]+)=([^&]*)/g;

        while ((tokens = re.exec(qs))) {
            params[decodeURIComponent(tokens[1])] = decodeURIComponent(
                tokens[2]
            );
        }

        return params;
    },

    updateQueryStringParameter: function (key, value, url) {
        if (!url) url = window.location.href;

        var re = new RegExp("([?&])" + key + "=.*?(&|#|$)(.*)", "gi"),
            hash;

        if (re.test(url)) {
            if (typeof value !== "undefined" && value !== null)
                return url.replace(re, "$1" + key + "=" + value + "$2$3");
            else {
                hash = url.split("#");
                url = hash[0].replace(re, "$1$3").replace(/(&|\?)$/, "");
                if (typeof hash[1] !== "undefined" && hash[1] !== null)
                    url += "#" + hash[1];
                return url;
            }
        } else {
            if (typeof value !== "undefined" && value !== null) {
                var separator = url.indexOf("?") !== -1 ? "&" : "?";
                hash = url.split("#");
                url = hash[0] + separator + key + "=" + value;
                if (typeof hash[1] !== "undefined" && hash[1] !== null)
                    url += "#" + hash[1];
                return url;
            } else return url;
        }
    },

    getYoutubeId: function (url) {
        var regExp =
            /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
        var match = url.match(regExp);
        return match && match[7].length == 11 ? match[7] : false;
    },

    getProductJSON: function (handle, callback) {
        return $.get(
            "/products/" + handle + "?view=json",
            null,
            callback,
            "text"
        );
    },

    hexToRgb: function (hex) {
        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result
            ? {
                  r: parseInt(result[1], 16),
                  g: parseInt(result[2], 16),
                  b: parseInt(result[3], 16)
              }
            : null;
    },

    flash: function (elements, color, duration) {
        var opacity = 100;
        color = color || "255, 255, 136";
        duration = duration || 1500;

        if (color.indexOf("#") > -1) {
            var rgbColor = theme.utils.hexToRgb(color);
            color = [rgbColor.r, rgbColor.g, rgbColor.b].join(",");
        }

        var interval = setInterval(function () {
            opacity -= 2.5;

            $(elements).css({
                background: "rgba(" + color + ", " + opacity / 100 + ")"
            });

            if (opacity <= 0) {
                clearInterval(interval);
                return;
            }
        }, duration / 40);
    },

    // Gets the rendered size of an image using object-fit
    getRenderedImgSize: function (
        contains,
        cWidth,
        cHeight,
        width,
        height,
        pos
    ) {
        var oRatio = width / height,
            cRatio = cWidth / cHeight;
        return function () {
            if (contains ? oRatio > cRatio : oRatio < cRatio) {
                this.width = cWidth;
                this.height = cWidth / oRatio;
            } else {
                this.width = cHeight * oRatio;
                this.height = cHeight;
            }
            this.left = (cWidth - this.width) * (pos / 100);
            this.right = this.width + this.left;
            return this;
        }.call({});
    },

    // Returns size info for an image rendered with object-fit
    getImgSizeInfo: function (img) {
        var pos = window
            .getComputedStyle(img)
            .getPropertyValue("object-position")
            .split(" ");
        return theme.utils.getRenderedImgSize(
            true,
            img.width,
            img.height,
            img.naturalWidth,
            img.naturalHeight,
            parseInt(pos[0])
        );
    },

    // Returns deep differences between objects, ignoring functions
    difference: function (object, base) {
        function changes(object, base) {
            return _.transform(object, function (result, value, key) {
                if (
                    typeof value !== "function" &&
                    !_.isEqual(value, base[key])
                ) {
                    var comparison =
                        _.isObject(value) && _.isObject(base[key])
                            ? changes(value, base[key])
                            : value;

                    if (!_.isNil(comparison)) {
                        result[key] = comparison;
                    }
                }
            });
        }
        return changes(object, base);
    },

    // Returns content of template placed into snippets/js-tempales.liquid
    getTemplate: function (template) {
        return $('[data-template-for="' + template + '"]').html();
    },

    // returns cross-browser CSS property name
    getCSSProperty: function (propertyName) {
        var properties;

        switch (propertyName) {
            case "transform":
                properties = [
                    "transform",
                    "msTransform",
                    "webkitTransform",
                    "mozTransform",
                    "oTransform"
                ];
                break;

            case "order":
                properties = [
                    "order",
                    "-webkit-box-ordinal-group",
                    "-webkit-order",
                    "-moz-order",
                    "-ms-flex-order"
                ];
                break;
        }

        function getSupportedPropertyName(properties) {
            for (var i = 0; i < properties.length; i++) {
                if (typeof document.body.style[properties[i]] != "undefined") {
                    return properties[i];
                }
            }
            return null;
        }

        return getSupportedPropertyName(properties);
    },

    updateOrder: function updateOrder($orderId) {
        $.ajax({
            url: "http://helpers.arcteryx.com.au/update_order/update_order.php",
            type: "POST",
            data: "order_id=" + $orderId
        }).done(function (data) {});
    }
};

window.accordions = window.accordions || {};

theme.SimpleAccordion = (function () {
    var defaults = {
        activeClass: "active",
        accordionClass: "simple-accordion",
        accordionTitleClass: "simple-accordion__title"
    };

    var selectors = {
        accordion: "[data-simple-accordion]",
        title: "." + defaults.accordionTitleClass
    };

    function SimpleAccordion(el) {
        this.$el = $(el);

        var mediaQuery = this.$el.data("simpleAccordion");

        if (mediaQuery) {
            this.mediaQuery = theme.settings.mediaQuery[mediaQuery];
        }

        var styleValue = "0.5s";

        this.animationDuration = styleValue.replace("s", "") * 1000;

        this.$titles = this.$el.find(selectors.title);
        if (!this.$titles.length) {
            this.$titles = this.$el.children().first();
            this.$titles.addClass(defaults.accordionTitleClass);
        }

        var self = this;

        if (self.mediaQuery) {
            _registerBreakpoints(self.mediaQuery);
        } else {
            initAccordion();
        }

        function initAccordion() {
            self.$el.addClass(defaults.accordionClass);
            self.$titles.on("click.accordion", _openClose);
        }

        function destroyAccordion() {
            self.$el.removeClass(defaults.accordionClass);
            self.$titles.off("click.accordion");
        }

        function _registerBreakpoints(mediaQuery) {
            enquire.register(mediaQuery, {
                match: function () {
                    initAccordion();
                },
                unmatch: function () {
                    destroyAccordion();
                }
            });
        }

        function _openClose() {
            var $currentTitle = $(this);

            var $target = $(this).next();
            var $active = self.$titles
                .filter("." + defaults.activeClass)
                .next();

            var close = false;
            if ($target[0] == $active[0]) {
                close = true;

                // If target is a link and accordion is open then go to link
                if (event.target.href || event.currentTarget.href) {
                    window.location.href =
                        event.target.href || event.currentTarget.href;
                    return;
                }
            }

            event.preventDefault();

            self.$titles.removeClass(defaults.activeClass);

            var height = {
                target: {},
                active: {}
            };

            height.target.current = $target.height();
            height.active.new = 0;
            height.active.current = $active.height();

            $active.height(height.active.current);

            if (!close) {
                $(this).addClass(defaults.activeClass);
                $target.height(height.target.current);
                $target.addClass(defaults.activeClass);
            }

            $active.removeClass(defaults.activeClass);

            if (!close) {
                $target.height("auto");
                $active.height("auto");
                $active.height(height.active.new);
                height.target.new = $target.get(0).scrollHeight;
                $target.offset();
                $active.offset();
                $currentTitle.trigger("accordionTransitionHeightCalc");

                if (!close) {
                    $(window).scrollTo($target, {
                        duration: self.animationDuration,
                        interrupt: !isMobile.apple.device,
                        offset: -100
                    });
                }

                $active.height("auto");
                $active.height(height.active.current);
                $target.height(height.target.current);
                $target.height(height.target.new);
            }

            $active.height(height.active.new);

            setTimeout(function () {
                $target.height("");
                $active.height("");
                $currentTitle.trigger("accordionTransitionEnd");

                // if (!close) {
                //   $(window).scrollTo($target, {
                //     duration: self.animationDuration,
                //     interrupt: !isMobile.apple.device,
                //     offset: -100
                //   });
                // }
            }, self.animationDuration);

            return;
        }
    }

    (function init() {
        var $accordions = $(selectors.accordion);
        if (!$accordions.length) {
            return;
        }
        for (var i = $accordions.length - 1; i >= 0; i--) {
            window.accordions[i] = new SimpleAccordion($accordions[i]);
        }
    })();

    return SimpleAccordion;
})();

theme.TinyBindCustom = (function () {
    function init() {
        tinybind.formatters.replace = function (value, search, replace) {
            return value.replace(search, replace);
        };

        tinybind.formatters.size = function (value) {
            return value.length;
        };

        tinybind.formatters.indexOf = function (array, value) {
            return array.indexOf(value) + 1;
        };

        tinybind.formatters.log = function (value) {
            console.info(value);
            return value;
        };

        tinybind.formatters.handle = function (string) {
            return theme.utils.handleize(string);
        };

        tinybind.formatters.startsWith = function (value, prefix) {
            return value.indexOf(prefix) === 0;
        };

        tinybind.binders.transformx = function (el, value) {
            el.style[theme.utils.getCSSProperty("transform")] =
                "translateX(" + value + ")";
        };

        tinybind.formatters.endsWith = function (value, suffix) {
            return value.indexOf(suffix, value.length - suffix.length) !== -1;
        };

        tinybind.formatters.getSizedImageUrl = function (imgUrl, width) {
            return slate.Image.getSizedImageUrl(
                imgUrl,
                width ? width : "{width}x"
            );
        };
    }
    return {
        init: init
    };
})();

theme.TinyBindCustom.init();

window.theme = window.theme || {};

theme.CompareToolManager = (function () {
    var DEBUG_MODE = false;

    var defaults = {
        comparePageURLBase:
            window.theme.compareToolSettings &&
            window.theme.compareToolSettings.compareToolURL
                ? window.theme.compareToolSettings.compareToolURL
                : "/pages/compare-tool",
        maxProductsCount:
            window.theme.compareToolSettings &&
            window.theme.compareToolSettings.maxProductsCount
                ? window.theme.compareToolSettings.maxProductsCount
                : 3
    };

    var Product = function (data) {
        _.extend(this, data);

        if (
            this.selected_variant &&
            this.selected_variant.id &&
            typeof this.selected_variant.id != "number"
        ) {
            this.selected_variant.id = parseInt(this.selected_variant.id);
        }

        if (typeof this.selected_variant_id != "number") {
            this.selected_variant_id = parseInt(this.selected_variant_id);
        }

        if (!this.handle) {
            console.error("Handle required");
        }

        if (!this.additionalDataLoaded || DEBUG_MODE) {
            this.loading = true;
            this._retrieveAdditionalData();
        }
    };

    Product.prototype._retrieveAdditionalData = function () {
        var self = this;

        var selectedVariantUrlParam = this.selected_variant_id
            ? "&variant=" + this.selected_variant_id
            : "";

        $.get(
            "/products/" +
                this.handle +
                "?view=compare-tool-data-json" +
                selectedVariantUrlParam,
            function (data) {
                if (Shopify.designMode) {
                    data = data.replace(/<[^>]*>?/gm, "");
                }

                _.extend(self, JSON.parse(data));

                if (!self.selected_variant) {
                    self.selected_variant = self.variants[0];
                }

                if (!self.selected_variant) {
                    return console.error("No variant found");
                }

                self.selected_variant_image = self.selected_variant.image;
                self.loading = false;
                self.additionalDataLoaded = true;

                theme.CompareToolManager.checkAllProductsLoaded();
            }
        );
    };

    function CompareToolManager(container) {
        this.data = {
            products: [],
            comparePageURL: defaults.comparePageURLBase,
            comparePageShareURL: "",
            maxProductsCount: defaults.maxProductsCount
        };

        this.containers = [];

        this.ready = false;

        this._restoreExistingProductSelections();
        this.bindAddButtonToProductGridItems();
        this.checkAllProductsLoaded();
    }

    CompareToolManager.prototype = _.assignIn(
        {},
        CompareToolManager.prototype,
        {
            bindAddButtonToProductGridItems: function () {
                var self = this;

                var $productGridItems = $(
                    ".product-grid-item:not([compare-tool-ready])"
                );

                $productGridItems.each(function () {
                    var $this = $(this);
                    var productHandle = this.dataset.productHandle;

                    const productCompareWrap = $this.find(
                        ".product__compare .input-checkbox-wrap"
                    );
                    const productCompareLabel =
                        productCompareWrap.find("label");

                    if (productCompareLabel) {
                        if (self.productExistInCompare(productHandle)) {
                            productCompareLabel.addClass("active");
                            $this.addClass("compare-tool-active");
                        }

                        productCompareLabel.on("click", function () {
                            var variantId =
                                productCompareLabel.data().variantId;

                            if (
                                variantId &&
                                self.toggleProductByHandleAndVariantId(
                                    productHandle
                                )
                            ) {
                                // Added successfully
                            } else if (
                                self.toggleProductByHandle(productHandle)
                            ) {
                                // Added successfully
                            } else {
                                // Not added successfully
                            }
                        });

                        this.dataset.compareToolReady = true;
                    }
                });
            },

            clearAll: function () {
                var i = this.data.products.length;
                while (i--) {
                    this.removeProductByIndex(i);
                }
            },

            checkAllProductsLoaded: function () {
                var i = this.data.products.length;

                while (i--) {
                    if (!this.data.products[i].additionalDataLoaded) {
                        return false;
                    }
                }

                this._cacheProductSelections();
                this._setReady();
            },

            _setReady: function () {
                this.ready = true;
                $(this.containers).trigger("compareToolReady");
            },

            _cacheProductSelections: function () {
                localStorage.setItem(
                    "compare-tool-selected-products",
                    JSON.stringify(this.data.products)
                );
            },

            _restoreExistingProductSelections: function () {
                var restoredProductsJSON = localStorage.getItem(
                    "compare-tool-selected-products"
                );
                var queryParamProducts = this._retrieveProductsFromURL();
                var cachedProducts = JSON.parse(restoredProductsJSON);

                if (!restoredProductsJSON && !queryParamProducts) {
                    return;
                }

                cachedProducts && cachedProducts.reverse();

                var products;

                // Check if param handles match cached handles
                if (cachedProducts && queryParamProducts) {
                    var cachedProductsHandles = _.map(cachedProducts, "handle");
                    var queryParamProductsHandles = _.map(
                        queryParamProducts,
                        "handle"
                    );

                    if (
                        _.isEqual(
                            _.sortBy(cachedProductsHandles),
                            _.sortBy(queryParamProductsHandles)
                        )
                    ) {
                        products = cachedProducts;
                    } else {
                        products = queryParamProducts;
                    }
                } else if (queryParamProducts) {
                    products = queryParamProducts;
                } else {
                    products = cachedProducts;
                }

                var i = products.length,
                    product;

                while (i--) {
                    product = new Product(products[i]);
                    this.addProduct(product);
                }
            },

            addProductByHandleAndVariantId: function (handle, variantId) {
                var product = new Product({
                    handle: handle,
                    selected_variant_id: variantId
                });
                this.addProduct(product);
            },

            toggleProductByHandleAndVariantId: function (handle, variantId) {
                if (this.productExistInCompare(handle)) {
                    this.removeProductByHandle(handle);
                    return false;
                }

                return this.addProductByHandleAndVariantId(handle, variantId);
            },

            toggleProductByHandle: function (handle) {
                if (this.productExistInCompare(handle)) {
                    this.removeProductByHandle(handle);
                    return false;
                }

                return this.addProductByHandle(handle);
            },

            removeProductByHandle: function (handle) {
                var productIndex = _.map(this.data.products, "handle").indexOf(
                    handle
                );
                this.removeProductByIndex(productIndex);
            },

            addProductByHandle: function (handle) {
                var product = new Product({ handle: handle });
                return this.addProduct(product);
            },

            productExistInCompare: function (productHandle) {
                return _.includes(
                    _.map(this.data.products, "handle"),
                    productHandle
                );
            },

            _retrieveProductsFromURL: function () {
                function decodeProductsHandlesString(string) {
                    return atob(string).split("+");
                }

                var queryParams = theme.utils.getQueryParams();

                if (!queryParams) {
                    return;
                }

                var encodedProductsHandles = queryParams.p;

                if (encodedProductsHandles) {
                    return _.map(
                        decodeProductsHandlesString(encodedProductsHandles),
                        function (handle) {
                            return new Product({ handle: handle });
                        }
                    );
                }
            },

            _generateComparePageURL: function () {
                var self = this;

                function createEncodedProductsHandlesString() {
                    return btoa(_.map(self.data.products, "handle").join("+"));
                }

                var encodedProductsHandlesString =
                    createEncodedProductsHandlesString();
                this.data.comparePageURL =
                    defaults.comparePageURLBase +
                    (encodedProductsHandlesString
                        ? "?p=" + encodedProductsHandlesString
                        : "");
            },

            addProduct: function (product) {
                if (this.data.products.length == this.data.maxProductsCount) {
                    console.error("Max products");
                    iziToast.error({ message: "Maximum products added" });
                    $(this.containers).trigger("productAddError");
                    return false;
                }

                if (this.productExistInCompare(product.handle)) {
                    console.error("Product already exists");
                    return false;
                }

                this.data.products.push(product);
                this._cacheProductSelections();
                this._generateComparePageURL();

                $(this.containers).trigger("productAdded");

                // Product Grid Item logic for Arc'teryx grid item implementation.
                var $productGridItem = $(
                    '.product-grid-item[data-product-handle="' +
                        product.handle +
                        '"]'
                );

                var $productGridItemCompareTool = $(
                    ".product__compare .input-checkbox-wrap label",
                    $productGridItem
                );
                $productGridItem.addClass("compare-tool-active");
                $productGridItemCompareTool.addClass("active");

                return true;
            },

            removeProductByIndex: function (index) {
                // Product Grid Item logic for Arc'teryx grid item implementation.
                var $productGridItem = $(
                    '.product-grid-item[data-product-handle="' +
                        this.data.products[index].handle +
                        '"]'
                );
                var $productGridItemCompareTool = $(
                    ".product__compare .input-checkbox-wrap label",
                    $productGridItem
                );
                $productGridItem.removeClass("compare-tool-active");
                $productGridItemCompareTool.removeClass("active");

                this.data.products.splice(index, 1);
                this._cacheProductSelections();
                this._generateComparePageURL();

                $(this.containers).trigger("productRemoved");
            }
        }
    );

    return new CompareToolManager();
})();

theme.CompareToolSheet = (function () {
    var CompareToolManager = theme.CompareToolManager;

    function CompareToolSheet(container) {
        this.container = container;
        this.$container = $(container);

        CompareToolManager.containers.push(this.container);

        _.extend(this, {
            view: {
                open: true,
                peaking: false
            },

            methods: {
                togglePeaking: this._togglePeaking.bind(this),
                removeSelectedProduct: this._removeSelectedProduct.bind(this),
                clearAll: this._clearAllProducts.bind(this)
            }
        });

        tinybind.bind(container, {
            methods: this.methods,
            compareTool: CompareToolManager,
            view: this.view
        });

        var self = this;

        this.$container.on("productAdded", function () {
            if (CompareToolManager.data.products.length > 1) {
                self.view.peaking = false;
            } else {
                self.view.peaking = true;
            }
        });

        this.$container.on("productAddError", function () {
            if (CompareToolManager.data.products.length > 0) {
                self.view.peaking = true;
            }
        });
    }

    CompareToolSheet.prototype = _.assignIn({}, CompareToolSheet.prototype, {
        _clearAllProducts: function () {
            CompareToolManager.clearAll();
        },

        _togglePeaking: function () {
            this.view.peaking = !this.view.peaking;
        },

        _removeSelectedProduct: function () {
            var productIndex = event.currentTarget.dataset.index;
            CompareToolManager.removeProductByIndex(productIndex);
        }
    });

    return CompareToolSheet;
})();

theme.CompareTool = (function () {
    var CompareToolManager = theme.CompareToolManager;

    var cache = {};

    var featureTypes = [
        {
            title: "product-description",
            formatter: function (feature, product) {
                if (!product.description) {
                    return null;
                }
                return product.description.split("</p>")[0] + "</p>";
            }
        },
        {
            title: "variant-price",
            formatter: function (feature, product) {
                if (!product.selected_variant) {
                    return "error";
                }
                var priceInCents = product.selected_variant.price;
                return Shopify.formatMoney(priceInCents);
            }
        },
        {
            title: "product-price",
            formatter: function (feature, product) {
                if (product.price_varies) {
                    return (
                        Shopify.formatMoney(product.price_min) +
                        " - " +
                        Shopify.formatMoney(product.price_max)
                    );
                }
                return Shopify.formatMoney(product.price_min);
            }
        },
        {
            title: "product-rating",
            formatter: function (feature, product) {
                return product.metafields.stamped.badge || null;
            }
        },
        {
            title: "variant-weight",
            formatter: function (feature, product) {
                if (!product.selected_variant.weight_in_unit) {
                    return null;
                }
                return "<p>" + product.selected_variant.weight_in_unit + "</p>";
            }
        },
        {
            title: "product-metafield",
            formatter: function (feature, product) {
                const metafield =
                    product.metafields?.[feature.namespace]?.[feature.key];

                const value = typeof metafield === "string"
                    ? metafield
                    : metafield?.value;

                if (!value) return null;

                if (value.includes("####")) {
                    return `<p>${value.replace("####", "")}</p>`;
                }

                if (value.includes("|")) {
                    const parts = value.split("|");
                    return `
            <ul>
                ${parts.map(p => `<li>${p.trim()}</li>`).join("")}
            </ul>
        `;
                }
                return `<p>${value}</p>`;
            }
        },
        {
            title: "product-options",
            template:
                '<div class="compare-tool-feature__option-thumbnails-wrapper">' +
                '<a class="compare-tool-feature__option-thumbnail" rv-each-variant="variants" rv-href="product.url | append \'?variant=\' | append variant.id">' +
                '<img loading="lazy" src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="' +
                'data-sizes="auto"' +
                'rv-if="variant.image"' +
                'rv-data-src="variant.image | getSizedImageUrl"' +
                'rv-class-lazyload="product.selected_variant_image"' +
                'rv-alt="variant | array_element optionWithPosition"/>' +
                "</a>" +
                "</div>",
            formatter: function (feature, product) {
                if (product.options_by_name[feature.option_name]) {
                    // Sometimes data is returned differently. Unsure why.
                    var option =
                            product.options_by_name[feature.option_name]
                                .option ||
                            product.options_by_name[feature.option_name],
                        values = option.values,
                        position = option.position,
                        optionWithPosition = "option" + position;

                    if (!feature.display_images) {
                        return values.join(", ");
                    }

                    var i = values.length,
                        j = product.variants.length,
                        value,
                        variant,
                        variants = [];

                    while (i--) {
                        value = values[i];
                        while (j--) {
                            variant = product.variants[j];
                            if (variant[optionWithPosition] == value) {
                                variants.push(variant);
                                break;
                            }
                        }
                    }

                    var el = document.createElement("DIV");
                    el.innerHTML = this.template;

                    tinybind.bind(el, {
                        variants: variants,
                        product: product,
                        optionWithPosition: optionWithPosition
                    });

                    return el.innerHTML;
                }
                return null;
            }
        }
    ];

    var emptyFeatureValueHTML =
        '<p class="compare-tool-feature__empty"> — </p>';

    function Section(data) {
        _.extend(this, data);
        if (this.title) {
            this.id = theme.utils.handleize(this.title);
        }
        this.valueFound = false;
        this.features = [];
    }

    function Feature(data) {
        _.extend(this, data, data.settings);
        this.valueFound = false;
        delete this.settings;
    }

    Feature.prototype.buildHTML = function (product) {
        var featureType = _.find(featureTypes, { title: this.type });
        if (!featureType) {
            return;
        }

        var html = featureType.formatter(this, product);

        if (html) {
            this.valueFound = true;

            if (this.hide_when_empty) {
                this.section.valueFound = true;

                console.log(this.section);
            }
        }

        return html || emptyFeatureValueHTML;
    };

    function CompareTool(container) {
        this.container = container;
        this.$container = $(container);

        cache.containerHTML = container.innerHTML;

        CompareToolManager.containers.push(this.container);

        _.extend(this, {
            data: {
                sections: [],
                features: []
            },

            view: {
                activeSlideIndex: 0,
                productsInView: 0,
                ready: false
            },

            methods: {
                removeSelectedProduct: this._removeSelectedProduct.bind(this),
                goToPreviousSlide: this.goToPreviousSlide.bind(this),
                goToNextSlide: this.goToNextSlide.bind(this),
                panSlides: this._panSlides.bind(this)
            }
        });

        this._getSections();
        this._getFeatures();

        tinybind.formatters.add_parameter = function (a, b) {
            if (Array.isArray(a)) {
                a.push(b);
                return a;
            }
            return [a, b];
        };

        tinybind.binders["compare-tool-feature-html"] = function (el, data) {
            // data must be an array, with [0] = product and [1] = feature
            var product = data[0],
                feature = data[1];

            el.innerHTML = feature.buildHTML(product);
        };

        tinybind.binders["swipe"] = function (el, options) {
            options = _.extend(options || {}, { domEvents: true });
            new Hammer(el, options);
        };

        tinybind.bind(container, {
            data: this.data,
            methods: this.methods,
            compareTool: CompareToolManager,
            view: this.view
        });

        var self = this;

        enquire.register(theme.settings.mediaQuery.largeUp, {
            match: function () {
                self.view.productsInView = 3;
                self.view.activeSlideIndex = 0;
            }
        });

        enquire.register(theme.settings.mediaQuery.medium, {
            match: function () {
                self.view.productsInView = 2;
                self.view.activeSlideIndex = 0;
            }
        });

        enquire.register(theme.settings.mediaQuery.small, {
            match: function () {
                self.view.productsInView = 2;
                self.view.activeSlideIndex = 0;
            }
        });

        if (CompareToolManager.ready) {
            this._onReady();
        } else {
            this.$container.one("compareToolReady", function () {
                self._onReady();
            });
        }
    }

    CompareTool.prototype = _.assignIn({}, CompareTool.prototype, {
        _panSlides: function () {
            if (!event.gesture) {
                return;
            }

            if (event.gesture.direction == Hammer.DIRECTION_LEFT) {
                this.goToNextSlide();
            } else if (event.gesture.direction == Hammer.DIRECTION_RIGHT) {
                this.goToPreviousSlide();
            }
        },

        _onReady: function () {
            var self = this;

            this.view.ready = true;

            this.bindAccordion();

            this.$container.on("productAdded", function () {});

            this.$container.on("productRemoved", function () {});
        },

        bindAccordion: function () {
            var $accordions = $(".compare-tool__accordion", this.container);
            $accordions.each(function () {
                new theme.SimpleAccordion(this);
            });
        },

        goToPreviousSlide: function () {
            if (this.view.activeSlideIndex > 0) {
                this.view.activeSlideIndex -= 1;
            }
        },

        goToNextSlide: function () {
            if (
                this.view.activeSlideIndex <
                CompareToolManager.data.maxProductsCount -
                    this.view.productsInView
            ) {
                this.view.activeSlideIndex += 1;
            }
        },

        _removeSelectedProduct: function () {
            var productIndex = event.currentTarget.dataset.index;
            CompareToolManager.removeProductByIndex(productIndex);
            if (window.theme?.compareToolSettings?.url) {
                const url = new URL(window.location.href);
                url.searchParams.delete("p");
                window.history.replaceState({}, document.title, url.toString());
            }
        },

        _getSections: function () {
            var sections = window.theme.compareToolSettings.sections;

            for (var i = 0; i < sections.length; i++) {
                this.data.sections.push(new Section(sections[i]));
            }
        },

        _getFeatures: function () {
            var sectionIDs = _.map(this.data.sections, "id"),
                features = window.theme.compareToolSettings.features,
                feature,
                section,
                sectionIndex;

            for (var i = 0; i < features.length; i++) {
                feature = new Feature(features[i]);

                // Add feature to section
                if (feature.section_title) {
                    sectionIndex = sectionIDs.indexOf(
                        theme.utils.handleize(feature.section_title)
                    );

                    if (sectionIndex > -1) {
                        section = this.data.sections[sectionIndex];
                        section.features.push(feature);
                        feature.section = section;
                    }
                }

                this.data.features.push(feature);
            }
        }
    });

    return CompareTool;
})();

$(document).ready(function () {
    var sections = new slate.Sections();
    sections.register("compare-tool-sheet", theme.CompareToolSheet);
    sections.register("compare-tool", theme.CompareTool);

    let hiddenRows = document.querySelectorAll('.compare-tool-section__features-row.hidden');
    if (hiddenRows.length) {
        hiddenRows.forEach((row) => {
            row.remove()
        });
    }
});
